<template>
  <transition :name="'fade'" mode="out-in">
    <CustomReveal
      v-if="recoverPassword"
      :isVisible="recoverPassword"
      revealId="card"
      class="recover-password-modal"
      v-on:close-reveal-card="closeRecoverPasswordModal"
    >
      <div class="secondary-menu">
          <div class="secondary-menu-body recover-password" id="card" data-reveal2>
            <div id="application-wrapper">
              <section class="modal recover-password">
                <div class="inner">
                  <div class="section-header">
                    <i class="back" @click="closeModal"></i>
                  </div>
                  <div v-if="invalidKey" class="section-body">
                    <div  id="recover__form" class="step">
                      <div class="form-inner">
                        <div class="headline">{{trans('invalid_token_message')}}</div>

                        <button
                            type="button"
                            class="btn btn-primary btn-rounded btn-long"
                            @click="try_again"
                        >
                          {{trans('try_again')}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="!sentScreen" class="section-body">
                    <div  id="recover__form" class="step">
                      <form data-abide2 data-vv-scope="recoverForm"  @submit.prevent="submit">
                        <div class="form-inner">
                          <div class="headline">{{ trans('last_your_password_title') }}</div>
                          <label>
                            <input
                                type="text"
                                v-model="email"
                                id="email"
                                name="email"
                                class="form-control dark"
                                :placeholder="trans('email_or_handle')"
                                :data-vv-as="trans('email')"
                                v-validate="'required'"
                                :class="{error: formErrors.email}"
                                @input="emailChanged"
                                required>

                            <span class="form-error" v-show="errors.has('recoverForm.email')" :class="{'is-visible': errors.has('recoverForm.email')}">
                                        {{ errors.first('recoverForm.email') }}
                                    </span>
                          </label>

                          <button
                              type="submit"
                              class="btn btn-primary btn-rounded btn-long"
                              id="button-recover"
                          >
                            {{trans('request_recovery_link')}}
                          </button>
                        </div>
                      </form>
                      <div class="form-enter-code">
                        <form data-vv-scope="enterCodeForm" @submit.prevent="enterCode">
                          <div class="headline">{{ trans('enter_code_here') }}</div>
                          <div class="row">
                            <label>
                              <input
                                  type="text"
                                  v-model="recovery_code"
                                  id="recovery_code"
                                  name="recovery_code"
                                  class="form-control dark"
                                  :placeholder="trans('recovery_code')"
                                  :data-vv-as="trans('recovery_code')"
                                  v-validate="'required|min:6'"
                                  :class="{error: recoverForm.recovery_code}"
                                  @input="codeChanged"
                                  required>

                              <span class="form-error" v-show="errors.has('enterCodeForm.recovery_code')" :class="{'is-visible': errors.has('enterCodeForm.recovery_code')}">
                                        {{ errors.first('enterCodeForm.recovery_code') }}
                                    </span>

                            </label>
                            <button
                                type="submit"
                                class="btn btn-primary btn-rounded"
                                id="button-enter-code"
                            >
                              {{trans('enter')}}
                            </button>
                          </div>
                        </form>
                      </div>
                      <div class="form-footer">


                        <a href="#" @click="help($event)">Need help?</a>
                      </div>
                    </div>
                  </div>
                  <div v-else class="section-body">
                    <div  id="message_sent" class="step">
                        <div class="form-inner">
                          <div class="headline" v-html="trans('we_sent_recovery_link')"></div>

                          <div class="text-center">
                            <span>Didn't get the email?</span>
                            <ul>
                              <li><span>{{trans('check_folder')}}</span></li>
                              <li><span>{{trans('make_sure_you_entered')}}</span></li>
                              <li><span>{{trans('request_new_link')}}</span></li>
                            </ul>
                          </div>
                          <div>
                            <button
                                type="button"
                                @click="sentScreen = 0"
                                class="btn btn-primary btn-rounded btn-long"
                                id="button-send-code"
                            >
                              {{trans('enter_code')}}
                            </button>
                            <button
                                type="button"
                                @click="openHome"
                                class="btn btn-default btn-rounded"
                                id="button-home"
                            >
                              {{trans('home.home')}}
                            </button>
                          </div>
                        </div>
                      <div class="form-footer">
                        <a href="#" @click="help($event)">Need help?</a>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
      </div>
    </CustomReveal>
  </transition>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';
import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';
import axios from "axios";

export default {
  name: "RecoverPasswordModal",
  components: {
      CustomReveal
  },
  mixins: [require('@general/lib/mixin').default],
  data() {
    return {
      email: null,
      recovery_code:null,
      process: false,
      sentScreen: false,
      recoverForm:{
        recovery_code: null
      },
      formErrors: {
          email: null
      }
    }
  },
  computed: {
      ...mapState({
          recoverPassword: state => state.modal.recoverPassword,
          invalidKey: state => state.modal.invalid_key,
      })
  },
  methods: {
      ...mapActions({
          recoverPasswordStart: 'recoverPasswordStart'
      }),
      try_again(){
        this.$store.commit('setModal', { recoverPassword: true, invalid_key: 0 });
      },
      openHome(){
        window.location.href = '/'
      },
      help(event) {
        if (typeof zE != "undefined") {
          event.preventDefault()
          zE.activate()
        }else{
          console.log('ZE not exists');
        }
      },
      emailChanged(){
          if (this.formErrors.email) {
              this.formErrors.email = null
          }
      },
      codeChanged(){
        if (this.recoverForm.recovery_code) {
          this.recoverForm.recovery_code = null
        }
      },
      validateCode(){
        let valid = true
        if (!this.recovery_code || this.recovery_code.length < 6 ) {
          this.recoverForm.recovery_code = true
          valid = false
        }

        /*const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (!re.test(String(this.email).toLowerCase())) {
            this.formErrors.email = true
            valid = false
        }*/

        return valid
      },
      validate(){
          let valid = true
          if (!this.email) {
              this.formErrors.email = true
              valid = false
          }

          /*const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!re.test(String(this.email).toLowerCase())) {
              this.formErrors.email = true
              valid = false
          }*/

          return valid
      },
      async sendCodeRequest(){
        this.process = true
        this.showLoadingButton('#button-enter-code');
        try {
          let response = await axios.get('/magicLinkAuth?code='+this.recovery_code)
          if (response.status === 200) {
            if(response.data.token){
              sessionStorage.setItem('token', response.data.token);
              sessionStorage.setItem('userId', response.data.user_id);

              localStorage.removeItem('userId');
              localStorage.removeItem('token');
              localStorage.removeItem('remember_login');
              window.location.href = '/discover';
            }
          }
          console.log('[Password Reset Form] Result', { response })

          this.process = false
          this.restoreLoadingButton('#button-enter-code')

        } catch (error) {
          console.log('[Password Reset Form] Error', { error })

          this.recoverForm.recovery_code = true
          this.errors.add({
            field: 'enterCodeForm.recovery_code',
            msg: 'Invalid code'
          });
        }
        this.restoreLoadingButton('#button-enter-code')

        this.process = false
      },
      async sendRequest(){
          this.process = true
          this.showLoadingButton('#button-recover');
          try {
              let response = await this.recoverPasswordStart({
                  email: this.email
              })
              console.log('[Password Reset Form] Result', { response })
              this.sentScreen = true;
              this.email = '';
              this.process = false
              this.restoreLoadingButton('#button-recover')
              if (response !== false) {
                  console.log('[Password Reset Form] Success')
                  //this.showSuccessNotification(response.message)
              }
          } catch (error) {
              console.log('[Password Reset Form] Error', { error })
          }
          this.restoreLoadingButton('#button-recover')

          this.process = false
      },
      enterCode(){
        console.log('[Enter code Form] Submit')
        if (this.validateCode()){
          this.sendCodeRequest()
        }
      },
      submit(){
          console.log('[Password Reset Form] Submit')
          if (this.validate()){
              this.sendRequest()
          }
      },
      closeModal(fallback) {
        if(this.sentScreen){
          this.sentScreen = 0;
        }else{
          this.closeRecoverPasswordModal();
        }
      }
  }
}
</script>